import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Alert from '@material-ui/core/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link as RRLink } from 'react-router-dom';
import Container from 'common/Container';
import { registerCreatorsGuildUser } from '../../../services/userService';

const BrandTnoCon = ({ onDark = false, sxTno = {}, sxCon = {} }) => (
  <Box component="span" sx={{ whiteSpace: 'nowrap', display: 'inline' }}>
    <Box
      component="span"
      sx={{
        fontWeight: 900,
        letterSpacing: '-0.07em',
        textShadow:
          '0.02em 0 0 currentColor, -0.02em 0 0 currentColor, 0 0.02em 0 currentColor, 0 -0.02em 0 currentColor',
        ...sxTno,
      }}
    >
      TNO
    </Box>
    <Box
      component="span"
      sx={{
        fontWeight: 200,
        letterSpacing: '-0.07em',
        marginLeft: '-0.06em',
        color: onDark ? 'rgba(255,255,255,0.72)' : '#4a505c',
        ...sxCon,
      }}
    >
      CON
    </Box>
  </Box>
);

const talentRoles = ['Host', 'Productor/a', 'Host y productor/a', 'Otro rol creativo'];
const EVENT_DATE = new Date('2026-04-20T10:00:00-04:00');
const EVENT_MAPS_URL =
  process.env.REACT_APP_CREATORSGUILD_MAPS_URL ||
  process.env.REACT_APP_PRESSSTART_MAPS_URL ||
  'https://share.google/W53TGyHp3m8uSLD5y';

const getCountdownParts = (targetDate) => {
  const now = new Date();
  const diffMs = Math.max(targetDate.getTime() - now.getTime(), 0);
  const totalSeconds = Math.floor(diffMs / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { days, hours, minutes, seconds };
};

const LandingCreatorsGuild = () => {
  const [form, setForm] = useState({
    fullName: '',
    idNumber: '',
    phone: '',
    email: '',
    programName: '',
    talentRole: '',
    mediaLink: '',
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: null, message: '' });
  const [countdown, setCountdown] = useState(() => getCountdownParts(EVENT_DATE));

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(getCountdownParts(EVENT_DATE));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    if (status.type) setStatus({ type: null, message: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: null, message: '' });
    const result = await registerCreatorsGuildUser(form);
    setLoading(false);
    if (!result.success) {
      setStatus({
        type: 'error',
        message: result.error || 'No se pudo guardar el registro. Intenta de nuevo.',
      });
      return;
    }
    setStatus({
      type: 'success',
      message:
        '¡Listo, creador! Tu registro quedó guardado. Revisa tu correo (y la carpeta de spam): te enviamos la bienvenida al Creators Guild con fecha, lugar y próximos pasos.',
    });
    setForm({
      fullName: '',
      idNumber: '',
      phone: '',
      email: '',
      programName: '',
      talentRole: '',
      mediaLink: '',
    });
  };

  return (
    <Box>
      <Box
        minHeight={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
        position={'relative'}
        sx={{
          background:
            'linear-gradient(135deg, rgba(8,28,18,0.97) 0%, rgba(18,72,48,0.95) 42%, rgba(34,140,95,0.88) 100%)',
          color: 'common.white',
          overflow: 'hidden',
          '&:before': {
            content: '" "',
            position: 'absolute',
            top: -100,
            right: -80,
            width: 320,
            height: 320,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(120,255,180,0.35), rgba(120,255,180,0))',
          },
        }}
      >
        <Container>
          <Box py={{ xs: 6, md: 10 }} position={'relative'} zIndex={2}>
            <Chip
              label={(
                <span>
                  <BrandTnoCon onDark />
                  <Box component="span" sx={{ fontWeight: 700 }}> 2026 | CREATORS GUILD</Box>
                </span>
              )}
              sx={{
                mb: 3,
                color: 'common.white',
                bgcolor: 'rgba(255,255,255,0.12)',
              }}
            />
            <Box
              width={{ xs: 340, md: 520 }}
              height={{ xs: 104, md: 156 }}
              sx={{
                mb: 3,
                backgroundImage: 'url(/images/logos/logo_white.PNG)',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'left center',
              }}
            />
            <Typography variant={'h2'} sx={{ fontWeight: 800, lineHeight: 1.15 }} gutterBottom>
              Creators Guild: Profesionalizando el ADN TNO.
            </Typography>
            <Typography variant={'h5'} sx={{ maxWidth: 880, opacity: 0.95, fontWeight: 400 }} paragraph>
              La jornada intensiva del <strong>TNO Media Lab</strong> donde los comunicadores se convierten en arquitectos de
              contenido.
            </Typography>
            <Typography variant={'h6'} sx={{ maxWidth: 880, opacity: 0.92, fontWeight: 600 }} paragraph>
              Lunes 20 de abril de 2026 (Día 1 · Día de Talentos) · 10:00 a. m. · Edif. Manzanares, Piso 2, Las Mercedes.
            </Typography>
            <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1}>
              <Link
                href={EVENT_MAPS_URL}
                target="_blank"
                rel="noreferrer"
                underline="hover"
                sx={{ color: '#b8ffd0', fontWeight: 700, fontSize: '1rem' }}
              >
                Ver ubicación en Google Maps
              </Link>
              <Link
                component={RRLink}
                to="/creators-guild/roadmap"
                underline="hover"
                sx={{ color: '#e8fff0', fontWeight: 700, fontSize: '0.95rem' }}
              >
                Presentación roadmap: Media Lab, formaciones, taller y agenda
              </Link>
            </Box>
            <Typography
              variant="body2"
              sx={{
                mt: 2.5,
                maxWidth: 640,
                opacity: 0.9,
                fontStyle: 'italic',
                borderLeft: '3px solid rgba(184,255,208,0.65)',
                pl: 2,
                py: 0.5,
                lineHeight: 1.65,
              }}
            >
              Sesión exclusiva para <strong>talentos y creadores</strong> de la red TNO Network.
            </Typography>
            <Box mt={4}>
              <Card
                sx={{
                  p: { xs: 2, md: 3 },
                  backgroundColor: 'rgba(255,255,255,0.10)',
                  border: '1px solid rgba(255,255,255,0.22)',
                  maxWidth: 560,
                }}
              >
                <Typography variant={'subtitle1'} sx={{ fontWeight: 700, mb: 2, color: 'common.white' }}>
                  Cuenta regresiva
                </Typography>
                <Grid container spacing={1.5}>
                  {[
                    { label: 'Días', value: countdown.days },
                    { label: 'Horas', value: countdown.hours },
                    { label: 'Minutos', value: countdown.minutes },
                    { label: 'Segundos', value: countdown.seconds },
                  ].map((item) => (
                    <Grid item xs={3} key={item.label}>
                      <Box textAlign={'center'}>
                        <Typography variant={'h4'} sx={{ fontWeight: 900, color: 'common.white' }}>
                          {String(item.value).padStart(2, '0')}
                        </Typography>
                        <Typography variant={'caption'} sx={{ color: 'rgba(255,255,255,0.9)' }}>
                          {item.label}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Card>
            </Box>
          </Box>
        </Container>
      </Box>

      <Container>
        <Box py={6}>
          <Card
            variant="outlined"
            sx={{
              p: { xs: 2.5, md: 4 },
              mb: 5,
              borderLeft: '4px solid',
              borderLeftColor: 'primary.dark',
              bgcolor: 'rgba(46,125,50,0.04)',
            }}
          >
            <Typography variant="overline" color="primary" sx={{ fontWeight: 800, letterSpacing: 2 }}>
              El propósito · más que voces, referentes
            </Typography>
            <Typography
              variant="h5"
              sx={{ fontWeight: 600, fontStyle: 'italic', lineHeight: 1.75, color: 'text.primary', mt: 2 }}
            >
              «En TNO no solo hablamos; profundizamos. El <strong>Creators Guild</strong> es el espacio para dominar las
              herramientas que separan el ruido de la verdadera influencia. Es el momento de unificar nuestro discurso y liderar
              el <strong>Hybrid Shift</strong>.»
            </Typography>
          </Card>
        </Box>
      </Container>

      <Box sx={{ backgroundColor: 'alternate.main' }}>
        <Container>
          <Box py={6}>
            <Typography variant={'h3'} gutterBottom sx={{ fontWeight: 700 }}>
              Coordenadas · Día de Talentos
            </Typography>
            <Typography variant={'h6'} paragraph component="div">
              Evento: <BrandTnoCon /> Creators Guild
            </Typography>
            <Typography paragraph>
              Fecha: Lunes, 20 de abril de 2026.
              <br />
              Hora: 10:00 a. m.
              <br />
              Lugar: Final Av. Principal de Las Mercedes, Edif. Manzanares, Piso 2 (lateral al C.C. Paseo Las Mercedes).
            </Typography>
            <Typography paragraph color={'textSecondary'} sx={{ lineHeight: 1.8 }}>
              <Box component={'span'} sx={{ fontWeight: 600, color: 'text.primary' }}>
                Estacionamiento.{' '}
              </Box>
              Quienes asistan en vehículo propio pueden estacionar en el Centro Comercial Paseo Las Mercedes.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              href={EVENT_MAPS_URL}
              target="_blank"
              rel="noreferrer"
              sx={{ mb: 2 }}
            >
              Abrir en Google Maps
            </Button>
            <Typography color={'textSecondary'}>
              Completa el registro para gestionar tu credencial y recibir el correo de bienvenida del Creators Guild.
            </Typography>
          </Box>
        </Container>
      </Box>

      <Container>
        <Box py={6}>
          <Typography variant={'h3'} align={'center'} sx={{ fontWeight: 700 }} gutterBottom>
            Registro Creators Guild
          </Typography>
          <Typography align={'center'} color={'textSecondary'} paragraph>
            Confirma tu asistencia como parte de la comunidad de creadores TNO Network.
          </Typography>

          <Box component={'form'} maxWidth={720} mx={'auto'} onSubmit={handleSubmit}>
            <Card variant={'outlined'} sx={{ p: { xs: 2, md: 4 } }}>
              {status.type === 'success' && (
                <Alert severity={'success'} sx={{ mb: 2 }} onClose={() => setStatus({ type: null, message: '' })}>
                  {status.message}
                </Alert>
              )}
              {status.type === 'error' && (
                <Alert severity={'error'} sx={{ mb: 2 }} onClose={() => setStatus({ type: null, message: '' })}>
                  {status.message}
                </Alert>
              )}
              <Typography variant={'h5'} sx={{ fontWeight: 700 }} gutterBottom>
                Datos personales
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField label={'Nombre y apellido'} required fullWidth value={form.fullName} onChange={handleChange('fullName')} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField label={'Cédula / ID'} required fullWidth value={form.idNumber} onChange={handleChange('idNumber')} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField label={'Teléfono'} required fullWidth value={form.phone} onChange={handleChange('phone')} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField label={'Correo electrónico'} type={'email'} required fullWidth value={form.email} onChange={handleChange('email')} />
                </Grid>
              </Grid>

              <Divider sx={{ my: 3 }} />

              <Typography variant={'h5'} sx={{ fontWeight: 700 }} gutterBottom>
                Tu voz en TNO
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label={'Nombre de tu programa o show'}
                    required
                    fullWidth
                    value={form.programName}
                    onChange={handleChange('programName')}
                    helperText={'Tal como aparece o lo conocen en la señal.'}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    select
                    label={'Rol principal'}
                    required
                    value={form.talentRole}
                    onChange={handleChange('talentRole')}
                    fullWidth
                  >
                    {talentRoles.map((r) => (
                      <MenuItem key={r} value={r}>
                        {r}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label={'Web o redes (opcional)'}
                    fullWidth
                    value={form.mediaLink}
                    onChange={handleChange('mediaLink')}
                  />
                </Grid>
              </Grid>

              <Box sx={{ mt: 4 }}>
                <Button
                  variant={'contained'}
                  color={'primary'}
                  size={'large'}
                  type={'submit'}
                  disabled={loading}
                  startIcon={loading ? <CircularProgress size={20} color={'inherit'} /> : null}
                >
                  {loading ? 'Enviando...' : 'Confirmar mi registro'}
                </Button>
              </Box>
            </Card>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default LandingCreatorsGuild;
